

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({
  components: {
    // InsBanner: () => import('@/components/base/InsBanner.vue'),
    InsCatLayout1: () => import('@/components/business/cms/InsCatLayout1.vue'),
    InsCatLayout2: () => import('@/components/business/cms/InsCatLayout2.vue')
    // InsCatLayout3: () => import('@/components/business/cms/InsCatLayout3.vue')
  }
})
export default class insNews extends Vue {
    cmsCategory: object = {}; // cms下单个目录的信息
    cmsCatTree: object[] = []; // cms目录
    contentList: object[] = []; // cms内容列表
    catId: number = 0; // Tree点击获取内容列表的目录id
    PageStyle: string = '0'; // catDetail页面类型

    // 根据设备类型获取CMSCategory信息
    getCategoryByDevice () {
      this.$Api.cms.getCategoryByDevice({ CatId: this.id, IsMobile: this.isMobile }).then((result) => {
        this.cmsCategory = result;
        this.PageStyle = result.PageStyle;
        if (result.PageStyle === '2') {
          this.getCategoryTree();
        } else if (result.PageStyle === '3' || result.Id === 40117) {
          this.getSubCatContents();
        }

        this.$nextTick(() => {
          if (result.Name) document.title = result.Name;
        });
      }).catch((error) => {
        console.log(error, 'error');
        this.$message({
          message: error,
          type: 'error'
        });
      });
    }

    // 获取cms该id下所有的Category
    getCategoryTree () {
      this.$Api.cms.getCategoryTree({ id: this.id }).then((result) => {
        if (result && result.length) {
          this.cmsCatTree = result;
          this.catId = result[0].Id;
          this.getContentsByCatId();
        } else {
          this.getContentsByCatId();
        }
      });
    }

    // 获取cms该id下所有的cms
    getContentsByCatId () {
      let catId = this.catId || this.id;
      this.$Api.cms.getContentsByCatId(catId, 1, 20).then((result) => {
        this.contentList = result.Data;
      });
    }

    // 获取 Category 和所有 SubCategory 的 cms 列表
    getSubCatContents () {
      this.$Api.cms.getSubCatContents({ CatId: this.id, IsMobile: this.isMobile }).then((result) => {
        console.log(result, ' 获取 Category 和所有 SubCategory 的 cms 列表');
        this.contentList = result.Data;
      });
    }

    // 树形控件选择的cms目录改变
    changeCatSelect (Id) {
      this.catId = Id;
      this.getContentsByCatId();
    }

    get id () {
      return this.$route.params.id;
    }

    get isMobile () {
      return this.$store.state.isMobile;
    }

    mounted () {
      this.getCategoryByDevice();
    }

    @Watch('id', { deep: true })
    onKeyChange () {
      this.cmsCategory = {};
      this.cmsCatTree = [];
      this.contentList = [];
      this.catId = 0;
      this.getCategoryByDevice();
    }

    @Watch('isMobile', { deep: true })
    onMediaChange () {
      if (this.PageStyle === '0') {
        this.cmsCategory = {};
        this.cmsCatTree = [];
        this.contentList = [];
        this.catId = 0;
        this.getCategoryByDevice();
      }
    }
}
